"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var customerOrderApi = _interopRequireWildcard(require("@/api/customerOrderApi.js"));
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ProjectInfoEdit',
  props: {
    cardTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      loading: false,
      initLoading: false,
      rowData: {},
      form: {
        orderName: '',
        projectNumber: '',
        companyId: '',
        salesPrice: 0,
        innerRemark: '',
        sendType: null,
        id: null
      },
      cardTypeOptions: [],
      companyOptions: [],
      // 公司选项
      orderDetail: null,
      // 存储完整的订单数据
      rules: {
        salesPrice: [{
          required: true,
          message: '请输入销售价',
          trigger: 'blur'
        }],
        sendType: [{
          required: true,
          message: '请选择发卡类型',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    // 获取公司列表
    getCompanyList: function () {
      var _getCompanyList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return suplierCouponsApi.getAllCompany('');
            case 1:
              res = _context.v;
              if (res && Array.isArray(res)) {
                this.companyOptions = res.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name || ''
                  };
                }).filter(function (item) {
                  return item.name;
                });
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.error('获取公司列表失败:', _t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCompanyList() {
        return _getCompanyList.apply(this, arguments);
      }
      return getCompanyList;
    }(),
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(row) {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.rowData = row;
              this.dialogVisible = true;
              this.initLoading = true;

              // 加载公司列表
              _context2.n = 1;
              return this.getCompanyList();
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return customerOrderApi.getOrderDetail(row.orderId);
            case 2:
              res = _context2.v;
              console.log('获取到详细订单数据:', res);
              this.orderDetail = res || {};

              // 初始化表单数据
              this.form = {
                orderName: res.orderName || '',
                projectNumber: res.projectNumber || row.projectNumber || '',
                companyId: res.companyId || row.companyId || '',
                salesPrice: res.salesPrice !== undefined ? Number(res.salesPrice) : row.price ? Number(row.price) : 0,
                sendType: res.sendType || row.sendType || null,
                id: row.orderId,
                innerRemark: res.innerRemark || ''
              };
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error('获取订单详情失败:', _t2);
              this.$message.error('获取订单详情失败: ' + (_t2.message || '未知错误'));

              // 如果获取订单详情失败，回退到使用传入的行数据
              this.form = {
                orderName: row.orderName || '',
                projectNumber: row.projectNumber || '',
                companyId: row.companyId || '',
                salesPrice: row.salesPrice ? Number(row.salesPrice) : row.price ? Number(row.price) : 0,
                sendType: row.sendType || null,
                id: row.orderId,
                innerRemark: row.innerRemark || ''
              };
            case 4:
              _context2.p = 4;
              this.initLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function open(_x) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    close: function close() {
      this.dialogVisible = false;
      this.form = {
        orderName: '',
        projectNumber: '',
        companyId: '',
        salesPrice: 0,
        innerRemark: '',
        sendType: null,
        id: null
      };
      this.orderDetail = null;
      this.loading = false;
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    submit: function submit() {
      var _this = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
          var basicData, _t3;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.p = _context3.n) {
              case 0:
                if (valid) {
                  _context3.n = 1;
                  break;
                }
                return _context3.a(2);
              case 1:
                _this.loading = true;
                _context3.p = 2;
                // 构建基础数据请求
                basicData = {
                  id: _this.form.id,
                  orderName: _this.form.orderName || '',
                  projectNumber: _this.form.projectNumber || '',
                  companyId: _this.form.companyId || '',
                  salesPrice: _this.form.salesPrice || 0,
                  innerRemark: _this.form.innerRemark || '',
                  sendType: _this.form.sendType || null
                };
                console.log('提交基础数据:', basicData);

                // 使用updateBasicData接口
                _context3.n = 3;
                return customerOrderApi.updateBasicData(basicData);
              case 3:
                _this.$message.success('保存成功');
                _this.dialogVisible = false;
                _this.$emit('doRefresh');
                _context3.n = 5;
                break;
              case 4:
                _context3.p = 4;
                _t3 = _context3.v;
                console.error('保存失败:', _t3);
                _this.$message.error('保存失败: ' + (_t3.message || '未知错误'));
              case 5:
                _context3.p = 5;
                _this.loading = false;
                _this.form = {
                  orderName: '',
                  projectNumber: '',
                  companyId: '',
                  salesPrice: 0,
                  innerRemark: '',
                  sendType: null,
                  id: null
                };
                return _context3.f(5);
              case 6:
                return _context3.a(2);
            }
          }, _callee3, null, [[2, 4, 5, 6]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  },
  watch: {
    cardTypeList: {
      handler: function handler(val) {
        console.log('接收到发卡类型列表:', val);
        this.cardTypeOptions = val || [];
      },
      immediate: true
    }
  }
};